// Price formatting shared by the product-card widgets. DataGate stores prices
// excl. VAT in rand; VAT is 15%. Returns null for missing/invalid amounts so
// callers can decide how to render "price on request".

var VAT = 1.15;

function withThousands(n) {
  return n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/** "R1,234.56" incl. VAT, from an excl-VAT amount. null if not a positive number. */
export function formatPriceIncl(excl) {
  var n = Number(excl);
  if (!n || isNaN(n) || n <= 0) return null;
  return 'R' + withThousands((n * VAT).toFixed(2));
}

/** "R1,234.56" excl. VAT. null if not a positive number. */
export function formatPriceExcl(excl) {
  var n = Number(excl);
  if (!n || isNaN(n) || n <= 0) return null;
  return 'R' + withThousands(n.toFixed(2));
}

// ---------------------------------------------------------------------------
// Price comparison layout (features.showPriceComparison, typically B2B and
// salesmen). When a retail (standard / B2C) price exists and differs from the
// customer's own price, the main price block renders exactly like the normal
// layout but with the RETAIL amounts, and the customer's own price moves to a
// small grey "Workshop: R465.00 incl. VAT" line below it (styled like the old
// "Retail:" comparison line). The workshop line carries `pf-retail-line` so
// Presentation Mode (shared/presentation.js) hides it; the main block is
// already retail, so presenting shows the same as a normal card.

/**
 * Small grey workshop line. opts:
 *   incl / excl   formatted customer price strings; incl wins, excl is used
 *                 (with "excl. VAT") when incl is null. Neither: returns ''.
 *   wasIncl       formatted promo "was" price (only shown with isPromo)
 *   isPromo       show the compact ON PROMO badge
 *   style         line style (default: the card's old retail-line style)
 *   taxStyle      style of the trailing tax text
 *   className     extra classes; tag: element name (default 'div')
 */
export function workshopLineHtml(opts) {
  var value = opts.incl || opts.excl;
  if (!value) return '';
  var tag = opts.tag || 'div';
  var style = opts.style || 'font-size:11px;color:#6b7280;margin-bottom:2px;';
  var taxStyle = opts.taxStyle || 'color:#9ca3af;font-size:10px;';
  var h = '<' + tag + ' class="pf-retail-line pf-workshop-line' + (opts.className ? ' ' + opts.className : '') + '" style="' + style + '">';
  h += 'Workshop: <span style="color:#9ca3af">' + value + '</span> <span style="' + taxStyle + '">' + (opts.incl ? 'incl. VAT' : 'excl. VAT') + '</span>';
  if (opts.isPromo && opts.wasIncl) h += '<span style="margin-left:6px;color:#9ca3af;font-size:10px;" title="Regular price">' + opts.wasIncl + '</span>';
  if (opts.isPromo) h += '<span style="margin-left:6px;padding:0 5px;border-radius:9999px;background:#fee2e2;color:#b91c1c;font-size:9px;font-weight:700;letter-spacing:.3px;white-space:nowrap;">ON PROMO</span>';
  return h + '</' + tag + '>';
}
